const TypeContract=[
  { value: "1", label: "Vente" },
  { value: "2", label: "Location" },
  { value: "3", label: "Vente+Location" },
];

export default TypeContract;
